module.exports = __webpack_public_path__ + "static/img/PC-5.a991728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/PC-5.png
// module id = 9mwK
// module chunks = 0